import React from 'react';

import IconArrowDown from '@pkg/assets/icons/arrow-down.svg?react';
import IconArrowUp from '@pkg/assets/icons/arrow-up.svg?react';

import { FieldToggle, type FieldToggleProps } from '../FieldToggle';

export type FieldDirectionType = 'asc' | 'desc';

export interface FieldDirectionProps
    extends Pick<FieldToggleProps, 'label' | 'ariaLabel' | 'backdropBlur' | 'disabled'> {
    direction?: FieldDirectionType;
    onToggle?: (newDirection: FieldDirectionType) => void;
}

export function FieldDirection({
    direction = 'asc',
    label,
    ariaLabel,
    backdropBlur = false,
    disabled = false,
    onToggle,
}: FieldDirectionProps) {
    return (
        <FieldToggle
            options={[
                { id: 'asc', icon: IconArrowUp },
                { id: 'desc', icon: IconArrowDown },
            ]}
            selected={direction}
            label={label}
            ariaLabel={ariaLabel}
            backdropBlur={backdropBlur}
            disabled={disabled}
            // TODO: Avoid this typecast by helping TypeScript
            // accept that `Direction` is compatible with `string`.
            onToggle={onToggle as FieldToggleProps['onToggle']}
        />
    );
}
